import React, { useMemo } from 'react'
import {
  Button, Text, Spacer
} from 'components/atoms'
import { useToggle } from 'hooks'
import PropTypes from 'prop-types'
import { PageAddModuleModal, Toast } from 'containers'
import { useEditorContext, actions } from 'context/EditorContext';
import { useUserContext } from 'context/UserContext';
import { produce } from 'immer'
import { useDispatch } from 'react-redux'
import { saveDraft } from 'redux/draftsSlice'
import { useParams, useHistory } from 'react-router-dom'
import { toast } from 'react-toastify';
import { generateEditorPath } from 'services/generators'

const EditorAddModule = ({ hasModules }) => {
  const [isOpen, toggle] = useToggle(false)
  const { pageId, lang, subweb } = useParams()
  const history = useHistory()

  const [{ user }] = useUserContext()
  const [{ pageLiveData, pageTitle }, dispatch] = useEditorContext();
  const dispatchRedux = useDispatch()

  const subwebData = useMemo(
    () => user.subwebs.find(({ slug }) => slug === subweb || encodeURIComponent(slug) === subweb),
    [subweb, user]
  )

  const moduleShouldUseActiveColor = ['Agenda', 'SubWebLinks', 'Contests']

  const handleAddModule = (module) => {
    if (
      module
      && module.options
      && 'getDefault' in module.options
      && typeof module.options.getDefault === 'function'
    ) {
      let newModuleProps = module.options.getDefault({ lang })

      // article middleware
      // adds title if first article and active color from subweb
      if (module.key === 'Article') {
        // check if is first article
        const alreadyHasArticle = pageLiveData.find(module => module.name === 'Article')
        const opts = { activeColor: subwebData.color }
        // in that case add the title
        if (!alreadyHasArticle) {
          newModuleProps = module.options.getDefault({
            lang,
            title: pageTitle,
            ...opts
          })
        }
        newModuleProps = module.options.getDefault({ lang, ...opts })
      }

      // agenda, contests, SubWebLinks middleware
      if (moduleShouldUseActiveColor.includes(module.key) && subwebData && subwebData.color) {
        newModuleProps = module.options.getDefault({ lang, color: subwebData.color })
      }


      const pageWithModule = produce(pageLiveData, draftState => {
        // eslint-disable-next-line no-param-reassign
        draftState.push(newModuleProps)
      })
      dispatch({
        type: actions.PAGE_DATA_UPDATE,
        data: pageWithModule,
      });
      dispatchRedux(saveDraft({ pageId, content: pageWithModule, lang }))
      const moduleId = `${module.key}-${pageWithModule.length - 1}`
      history.push(generateEditorPath({
        lang, pageId, subweb, moduleId
      }))

      toast.success(
        <Toast
          type="success"
          title={`${module.options.label} adicionado`}
          description="Edite o módulo antes de gravar"
        />
      );
    }
  }

  return (
    <>
      <PageAddModuleModal isOpen={isOpen} toggle={toggle} onSelect={handleAddModule} />
      {!hasModules && (
        <Spacer bottom="xl">
          <Text>Página em branco, comece por adicionar o primeiro módulo:</Text>
        </Spacer>
      )}
      <Button modifiers={['dark']} onClick={toggle}>
        Adicionar módulo
      </Button>

    </>
  )
}


EditorAddModule.propTypes = {
  hasModules: PropTypes.bool,
}

EditorAddModule.defaultProps = {
  hasModules: true,
}

export default EditorAddModule
